
const Helpers = {
    // get height of element
    getHeight: (elem) => {
        return Math.max(elem.scrollHeight, elem.offsetHeight, elem.clientHeight);
    },

    // get window size
    getWindowSize: () => {
        let winH;
        let winW;
        if (window.innerWidth) {
            winW = window.innerWidth;
            winH = window.innerHeight;
        } else if (document.body && document.body.offsetWidth) {
            winW = document.body.offsetWidth;
            winH = document.body.offsetHeight;
        }
        return {height: winH, width: winW};
    },

    equalHeight: (container, equal) => {
        const self = this;
        const containerEl = Array.from(document.querySelectorAll(container));

        if (containerEl.length) {
            containerEl.forEach(
              (el) => {
                  const equalelements = el.querySelectorAll(equal);
                  let highest = 0;
                  equalelements.forEach(
                    (elem) => {
                        if (self.getHeight(elem) > highest) {
                            highest = self.getHeight(elem);
                        }
                        elem.style.height = highest + 'px';
                    }
                  );
              }
            );
        }
    },
};

module.exports = Helpers;




// WEBPACK FOOTER //
// ./src/js/modules/helpers.js